export enum Constants {
  QRS_ADD_NEW_QR = 'QRS_ADD_NEW_QR',
  QRS_UPDATE_QRS = 'QRS_UPDATE_QRS',
  QRS_SET_LOADING = 'QRS_SET_LOADING',
  QRS_SET_DOWNLOAD_ITEMS = 'QRS_SET_DOWNLOAD_ITEMS',
  QRS_SET_UPLOAD_LOADER = 'QRS_SET_UPLOAD_LOADER',
  QRS_SET_DOWNLOAD_LOADER = 'QRS_SET_DOWNLOAD_LOADER',
  QRS_SET_MAPPING_LOADER = 'QRS_SET_MAPPING_LOADER'
}